import React from 'react';

// Product mark: the gear from the extension icon, redrawn as a vector so it stays sharp
// at sidebar size (the PNG icon is 128px and too detailed below ~48px). It is drawn with
// the theme's text and canvas colours, so it inverts with light and dark.
const GEAR = 'M10.41 6.53 L10.46 4.56 L13.54 4.56 L13.59 6.53 L14.75 7.01 L16.17 5.65 L18.35 7.83 L16.99 9.25 L17.47 10.41 L19.44 10.46 L19.44 13.54 L17.47 13.59 L16.99 14.75 L18.35 16.17 L16.17 18.35 L14.75 16.99 L13.59 17.47 L13.54 19.44 L10.46 19.44 L10.41 17.47 L9.25 16.99 L7.83 18.35 L5.65 16.17 L7.01 14.75 L6.53 13.59 L4.56 13.54 L4.56 10.46 L6.53 10.41 L7.01 9.25 L5.65 7.83 L7.83 5.65 L9.25 7.01 Z M14.70 12.00 A2.7 2.7 0 1 0 9.30 12.00 A2.7 2.7 0 1 0 14.70 12.00 Z';

function Logo({ size = 28, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={`flex-shrink-0 select-none ${className}`}
    >
      <rect width="24" height="24" rx="6" fill="rgb(var(--pp-text))" />
      <path d={GEAR} fill="rgb(var(--pp-bg))" fillRule="evenodd" strokeLinejoin="round" stroke="rgb(var(--pp-bg))" strokeWidth="0.8" />
      <circle cx="12" cy="12" r="1.25" fill="rgb(var(--pp-accent))" />
    </svg>
  );
}

export default Logo;
